import { forwardRef, useImperativeHandle, useState } from 'react'
import { Form, Input, Modal, Spin } from 'antd'
import { updateAreaEncryptStatus } from '../../common/request'
import ResponseCode from '../../common/response-code'

const UpdateAreaEncryptStatusModal = forwardRef((props, ref) => {
  const [formRef] = Form.useForm()
  const [modalVisible, setModalVisible] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentEncryptStatus, setEncryptStatus] = useState(false)

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = (encryptStatus) => {
    setModalVisible(true)
    setEncryptStatus(encryptStatus)
  }

  const hideModal = () => {
    setModalVisible(false)
    formRef.resetFields()
  }

  const onOk = () => {
    formRef.validateFields().then(fields => {
      setLoading(true)
      updateAreaEncryptStatus({
        ...fields,
        status: Number(!currentEncryptStatus)
      }).then(res => {
        if (res.code === ResponseCode.success) {
          Modal.success({
            title: '操作成功',
            content: `更新区域加密状态成功`
          })
          hideModal()
          props.onSuccess()
        } else {
          Modal.error({
            title: '错误',
            content: res.msg,
            centered: true
          })
        }
      }).finally(() => {
        setLoading(false)
      })
    })
  }

  return (
    <Modal
      title="修改区域加密状态"
      open={ modalVisible }
      onOk={ onOk }
      onCancel={ hideModal }
      confirmLoading={ loading }
    >
      <Spin spinning={ loading }>
        <div className="my-4 px-4">
          <Form form={ formRef }>
            <Form.Item
              label="请输入安全密码" required name="pwd" rules={ [{
              required: true,
              message: '请输入安全密码'
            }] }>
              <Input.Password placeholder="请输入安全密码"></Input.Password>
            </Form.Item>
          </Form>
        </div>
      </Spin>
    </Modal>
  )
})

export default UpdateAreaEncryptStatusModal
